import React from "react";

import Fieldset from "./fieldset.jsx";

/**
 * @typedef {object} PageProps
 * @property {boolean} showTitle - Whether to show the title of the page.
 * @property {string | false} title - The title of the page.
 * @property {object[]} components - The components to render on the page.
 * @property {Function} setResponse - The function to call when a response is set.
 * @property {Function} clearResponse - The function to call when a response is cleared.
 */

/**
 *
 * @type {React.FC<PageProps>}
 * @returns {React.ReactElement} - the page
 */
function Page({ showTitle, title, components, showIncompleteFeedback }) {
  return (
    <div>
      {showTitle && (
        <h3 className="fr-font-medium fr-text-lg fr-mb-4 fr-text-zinc-800 fr-mr-auto">
          {title}
        </h3>
      )}
      {components?.map((component) => (
        <Fieldset
          component={component}
          key={component.componentId}
          showIncompleteFeedback={showIncompleteFeedback}
        />
      ))}
    </div>
  );
}

export default Page;
